import * as siteStats from "@/lib/siteStats";
import type { StatEvent } from "./lib/analytics";
import { site } from "./current";

// The open TASMA website's statistics events (src/lib/siteStats.ts, shared by every website kind), for the report
// worked out here in the browser (lib/stats-report-core.ts, the same code the website's own Statistics page used).

/** Every event between two days (inclusive, UTC, YYYY-MM-DD), oldest first. */
export const loadEvents = (from: string, to: string): Promise<StatEvent[]> => siteStats.loadEvents(site(), from, to);

export const firstDay = (): Promise<string | null> => siteStats.firstDay(site());
